<template>
  <v-dialog v-model="dialog" max-width="550">
    <v-card class="qr-card semi-rounded" color="white">
      <div class="pa-10 d-flex flex-column align-center">
        <div style="color: var(--primary-color-blue);" class="title text-center mb-10">
          {{ $t("tips.tag_id.tag_placement") }}
        </div>
        <v-img
          max-width="200"
          max-height="200"
          :src="require('@/assets/images/tag_info_dialog.png')"
        ></v-img>
        <v-btn
          style="background: var(--primary-color-blue); color: white; border-radius: 16px;"
          class="py-8 w-100 mt-10 px-10"
          x-large
          @click="dialog = false"
        >
          {{ $t("actions.ok") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["triggerDialog"],
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    triggerDialog: {
      handler() {
        this.dialog = true;
      },
    },
  },
};
</script>
